/** @format */
import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { Attainment, CreditRange, Module } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { isDegreeProgramme, isStudyModule } from '../../../service/module-entity.service';
import { ModuleStateObject, PlanData, PlanStateObject } from '../../../service/plan-state.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-rule-module-box',
    templateUrl: './rule-module-box.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class RuleModuleBoxComponent implements OnInit, OnChanges {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.plan.rules.ruleModuleBox',
        directiveName: 'sisRuleModuleBox',
    };

    moduleStateObject: ModuleStateObject;
    attainment: Attainment;
    visibleCredits: CreditRange;
    showExpiryWarning: boolean;
    dimmed = false;

    @Input() module: Module;
    @Input() planValidationResult: any;
    @Input() planStateObject: PlanStateObject;
    @Input() planData: PlanData;
    @Input() isImplicit: boolean;

    ngOnInit() {
        this.showExpiryWarning = true;
        if (this.attainment) {
            this.visibleCredits = { min: this.attainment.credits, max: this.attainment.credits };
        } else if (isDegreeProgramme(this.module) || isStudyModule(this.module)) {
            this.visibleCredits = this.module.targetCredits;
        }
    }

    ngOnChanges() {
        this.moduleStateObject = _.get(this.planStateObject.modules, this.module.id);
        if (this.moduleStateObject) {
            this.attainment = this.planData.attainmentsById[this.moduleStateObject.attainmentId];
        }
    }

    openModuleInfoModal() {}
}
